(function () {
  var DESKTOP_QUERY = '(min-width: 1025px)';
  var specBlock = null;
  var placeholder = null;
  var mq = null;
  var retryCount = 0;

  function textOf(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function scoreSpecGrid(grid) {
    var text = textOf(grid).toLowerCase();
    var keywords = [
      'peak motor',
      'rated power',
      'motor',
      'battery',
      'max speed',
      'max range',
      'range',
      'weight',
      'light weight',
      'braking system',
      'brake',
      'max load',
      'load capacity',
      'max power',
      'top speed',
      'charging time',
      'capacity',
      'torque',
      'mileage',
      'assistant-mileage'
    ];
    var score = keywords.reduce(function (total, keyword) {
      return total + (text.indexOf(keyword) !== -1 ? 1 : 0);
    }, 0);
    var childCount = grid.children ? grid.children.length : 0;
    var inRightColumn = !!grid.closest('.halo-productView-right');
    if (grid.closest('.dyu-specs-under-gallery')) return 0;
    if (childCount < 4) return 0;
    if (!inRightColumn && !grid.closest('.productView-product')) return 0;
    return score;
  }

  function findSpecBlock() {
    if (specBlock && document.documentElement.contains(specBlock)) return specBlock;
    var grids = Array.prototype.slice.call(document.querySelectorAll('.yg-product-block__grid'));
    var candidates = grids
      .map(function (grid) {
        return { grid: grid, score: scoreSpecGrid(grid) };
      })
      .filter(function (item) {
        return item.score >= 3;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });
    var grid = candidates.length ? candidates[0].grid : null;
    specBlock = grid ? grid.closest('.productView-moreItem') || grid : null;
    return specBlock;
  }

  function rememberOriginal(block) {
    if (!block || placeholder) return;
    placeholder = document.createElement('span');
    placeholder.className = 'dyu-spec-original-anchor';
    placeholder.hidden = true;
    block.parentNode.insertBefore(placeholder, block);
  }

  function targetPosition() {
    var left = document.querySelector('.halo-productView-left');
    var media = left && left.querySelector('.productView-images-wrapper');
    var policy = left && left.querySelector('.new-policy-container');
    if (!left || !media) return null;
    return { parent: left, before: policy || media.nextSibling };
  }

  function moveUnderGallery() {
    var block = findSpecBlock();
    var target = targetPosition();
    if (!block || !target) return false;
    rememberOriginal(block);
    block.classList.add('dyu-specs-under-gallery');
    block.setAttribute('data-dyu-specs-location', 'gallery');
    if (block.parentNode !== target.parent || block.nextSibling !== target.before) {
      target.parent.insertBefore(block, target.before);
    }
    return true;
  }

  function restoreOriginal() {
    if (!specBlock || !placeholder || !placeholder.parentNode) return;
    specBlock.classList.remove('dyu-specs-under-gallery');
    specBlock.removeAttribute('data-dyu-specs-location');
    placeholder.parentNode.insertBefore(specBlock, placeholder.nextSibling);
  }

  function applyLayout() {
    if (!document.body.classList.contains('template-product')) return;
    if (!mq) mq = window.matchMedia(DESKTOP_QUERY);
    if (mq.matches) {
      moveUnderGallery();
    } else {
      restoreOriginal();
    }
  }

  function scheduleRetries() {
    if (retryCount >= 12) return;
    retryCount += 1;
    window.setTimeout(function () {
      var moved = moveUnderGallery();
      if (!moved) scheduleRetries();
    }, retryCount * 350);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    if (!document.body.classList.contains('template-product')) return;
    mq = window.matchMedia(DESKTOP_QUERY);
    applyLayout();
    scheduleRetries();
    if (mq.addEventListener) {
      mq.addEventListener('change', applyLayout);
    } else if (mq.addListener) {
      mq.addListener(applyLayout);
    }
    window.addEventListener('load', function () {
      applyLayout();
      scheduleRetries();
    });
  });
})();
